export { default } from './NearbySpots';
